<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"
                         :options="[{ type: 'text', label: '문서번호', readonly: true, visibleWhenValue: true}]"/>

    <div class="writeGridContainer">
      <div class="writeGridLineItem">
        <div>안전보건교육</div>
        <div class="print-input p-1 flex flex-wrap cursor-pointer" @click.stop="showListPopup = true">
          <div class="tag flex items-center gap-2 p-2" v-for="안전보건교육 in form.불러온안전보건교육" :key="`안전보건교육_${안전보건교육.id}`">
            <span>{{ 안전보건교육.content.교육진행[0].교육명 }}({{ 안전보건교육.id }})</span>
            <feather-icon v-if="!board.readonly" class="cursor-pointer" icon="XIcon" style="width: 20px; height: 20px"
                          @click.stop="onClickRemove987(안전보건교육)"/>
          </div>
        </div>
      </div>
    </div>

    <!-- 교육정보 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>교육인원</div>
          <div class="flex gap-2" style="align-items: center;">
            <span class="whitespace-no-wrap">대상</span>
            <p v-if="isPrint" class="print-input">{{ form.교육인원대상자수 }}</p>
            <comma-input v-else v-model="form.교육인원대상자수" type="number" readonly/>
            <span class="whitespace-no-wrap">명 / 참석</span>
            <p v-if="isPrint" class="print-input">{{ form.교육인원참석자수 }}</p>
            <comma-input v-else v-model="form.교육인원참석자수" type="number" readonly/>
            명
          </div>
        </div>

        <div class="writeGridLineItem">
          <div>교육구분</div>
          <div class="grid" style="grid-template-columns: 300px 300px;">
            <div v-for="item in form.교육구분" class="flex gap-2 justify-between mx-2"
                 style="align-items: center; min-height: 40px;" :key="`edu-check-${item.text}`">
              <PrintCheckbox :label="item.text" :value="item.check" white-space-nowrap/>

              <p v-if="isPrint" v-show="item.check" class="print-input">{{ item.comment ? item.comment : '' }}</p>
              <vs-input v-else v-show="item.check" v-model="item.comment" placeholder="입력" style="width: 150px;"
                        readonly/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 교육진행 -->
    <table-custom
      class="mt-6 mb-4"
      :board="board"
      :is-print="isPrint"
      :default-size="0"
      :min-size="0"
      :controls="false"
      :border-x="false"
      title="교육진행"
      :tableData="[
        { id: '교육명', title: '교육(과목)명', type: 'text', readonly: true },
        { id: '강사', title: '강사', type: 'text', readonly: true },
        { id: '교육일자', title: '교육일자', type: 'date', readonly: true },
        { id: '교육시간', title: '교육시간', type: 'period', width: '300px', readonly: true },
        { id: '교육장소', title: '교육장소', type: 'text', readonly: true },
        { id: '학습방법', title: '학습방법', type: 'text', readonly: true },
        { id: '평가방법', title: '평가방법', type: 'text', readonly: true },
      ]"
      v-model="form.교육진행"
    />

    <!-- 참석자 명단 -->
    <table-custom
      class="mt-6 mb-5"
      :board="board"
      :is-print="isPrint"
      :default-size="0"
      :min-size="0"
      :controls="false"
      title="참석자 현황"
      :tableData="[
        { id: '업체명', title: '부서(업체)명', type: 'string', readonly: true },
        { id: '인원', title: '인원', type: 'string' },
        { id: '교육평가', title: '교육평가', type: 'radio', radioItems: [{ value: '생략' }, { value: '합격' }, { value: '불합격' }], readonly: true },
      ]"
      v-model="form.참석자명단"/>

    <!-- 교육결과 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육결과</h5>
        </vs-col>
      </vs-row>
      <div class="writeGridContainer">
        <div>
          <div>담당자</div>
          <p v-if="isPrint" class="print-input">{{ form.교육결과_담당자.담당자 }}</p>
          <ml-input v-else v-model="form.교육결과_담당자.담당자" :readonly="board.readonly"/>
        </div>
        <div>
          <div>작성일</div>
          <p v-if="isPrint" class="print-input">{{ form.교육결과_담당자.작성일 }}</p>
          <date-selector v-else v-model="form.교육결과_담당자.작성일" :readonly="board.readonly"/>
        </div>
        <div class="writeGridLineItem">
          <div>의견</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.교육결과_담당자.의견 }} </span>
          <ml-textarea v-else v-model="form.교육결과_담당자.의견" :readonly="board.readonly"/>
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>교육책임자</div>
          <p v-if="isPrint" class="print-input">{{ form.교육결과_교육책임자.담당자 }}</p>
          <ml-input v-else v-model="form.교육결과_교육책임자.담당자" :readonly="board.readonly"/>
        </div>
        <div>
          <div>작성일</div>
          <p v-if="isPrint" class="print-input">{{ form.교육결과_교육책임자.작성일 }}</p>
          <date-selector v-else v-model="form.교육결과_교육책임자.작성일" :readonly="board.readonly"/>
        </div>
        <div class="writeGridLineItem">
          <div>의견</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.교육결과_교육책임자.의견 }} </span>
          <ml-textarea v-else v-model="form.교육결과_교육책임자.의견" :readonly="board.readonly"/>
        </div>
      </div>
    </div>

    <!-- 참고사항 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 참고사항</h5>
        </vs-col>
      </vs-row>
      <span v-if="isPrint" class="print-textarea"> {{ form.참고사항 }} </span>
      <ml-textarea v-else v-model="form.참고사항" :readonly="board.readonly"/>
    </div>

    <!-- 안전보건교육 상세 -->
    <div class="my-4">
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 안전보건교육 상세</h5>
        </vs-col>
      </vs-row>
      <table>
        <tr v-for="(item, index) in form.loadFormList" :key="index">
          <td>
            <div class="flex items-center gap-2" style="color: #7E72F2" @click="openNewWindow(item.id)">
              <p>- {{ item.content.교육구분 ? item.content.교육구분 : '' }}({{ getDataTeam(item.content) }})</p>
              <feather-icon icon="ExternalLinkIcon" style="width: 20px; height: 20px"/>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <!-- 교육 참여인원 상세 -->
    <div class="my-4">
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육 참여인원 상세</h5>
        </vs-col>
      </vs-row>
      <vs-button color="secondary" @click="printMemberList" class="custom-btn">
        <div class="flex items-center justify-center gap-2">
          <feather-icon icon="DownloadIcon" style="width: 20px; height: 20px"/>
          <p>날인부 출력</p>
        </div>
      </vs-button>
    </div>

    <!--    <div>-->
    <!--      <PrintMember v-model="form.loadFormList" :board="board" />-->
    <!--    </div>-->

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint"
                        :readonly="board.readonly"></file-upload-module>

    <PopupLoadBoard987
      title="안전보건교육 불러오기"
      :setBoardId="987"
      v-model="showListPopup"
      :setField="{
        fieldId: form.stdInfo.field_id,
        fieldName: form.stdInfo.field_name,
      }"
      @selectRowData="loadGoalData"
      multi-select
    />
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector";
import CustomOptionSelector from "@/components/selector/CustomOptionSelectorObject";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

import KPagination from "@/components/kPagination/kPagination";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import {valueDisasters} from "@/util/DisasterDataUtil";
import TableCustom from "@/components/TableCustom.vue";
import SignField from "@/components/SignField.vue";
import PopupSearchEmployeeCheckbox from "@/popup/PopupSearchEmployeeCheckbox.vue";
import CustomLabel from "@/components/CustomLabel.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import {CompanyData} from "@/data/DksteeTeamlData";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import PrintRadio from "@/components/print/PrintRadio.vue";
import PopupLoadBoard987 from "@/views/boards/single-page/1007/PopupLoadBoard987.vue";
import PrintMember from "@/views/boards/single-page/1007/PrintMember.vue";

export default {
  components: {
    PrintMember,
    PopupLoadBoard987,
    PrintRadio,
    RadioGroup,
    PrintCheckbox,
    CustomLabel,
    PopupSearchEmployeeCheckbox,
    PhotoUploadGridModule,
    FieldSelectModule,
    CustomOptionSelector,
    FileUploadModule,
    DateSelector,
    DisasterClassSelector,
    TimeSelector,
    KPagination,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    SearchNavItemSelect,
    TableCustom,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      showListPopup: false,
      // =============== 이전 문서 불러오기 ===============
      isMounted: false,
      customButton: null,
      disasterTypes: [{text: "전체선택", value: ""}, ...valueDisasters()],
      searchTypes: [
        {value: "stdInfo.field_name", text: "현장명"},
        {value: "inputD_1", text: "재해일시"},
        {value: "inputD_3", text: "발생형태"},
        {value: "stdInfo.department", text: "소속2"},
        {value: "stdInfo.section", text: "소속1"},
        {value: "stdInfo.writer_name", text: "작성자"},
      ],
      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10,
      },
      // 검색
      search: {
        date: "", // 작성일
        disasterType: "", // 발생형태
        searchType: "", // 검색조건
        searchKeyword: "", // 키워드
      },

      // =============== FORM ===============
      공장리스트: CompanyData,
      form: {
        stdInfo: {},
        loadFormList: [],

        공장: "",
        공장형태: [
          {check: false, label: "직영"},
          {check: false, label: "수급업체"},
        ],
        팀업체: [
          {
            공장: {},
            팀1차: {},
            팀2차: {},
            팀커스텀: "",
          }
        ],
        팀리스트1차: [[]],
        팀리스트2차: [[]],
        교육인원대상자수: 0,
        교육인원참석자수: 0,
        교육구분:
          [
            {check: false, comment: '', value: "관리감독자교육", text: "관리감독자교육"},
            {check: false, comment: '', value: "환경교육직무보수교육", text: "환경교육직무보수교육"},
            {check: false, comment: '', value: "TQM교육", text: "TQM교육"},
            {check: false, comment: '', value: "외부업체교육", text: "외부업체교육"},
            {check: false, comment: '', value: "소방교육", text: "소방교육"},
            {check: false, comment: '', value: "특별안전보건", text: "특별안전보건교육"},
            {check: false, comment: '', value: "정기안전보건", text: "정기안전보건교육"},
            {check: false, comment: '', value: "신입사원교육", text: "신입사원교육"},
            {check: false, comment: '', value: "직무전환교육", text: "직무전환교육"},
            {check: false, comment: '', value: "기타교육", text: "기타교육"},
          ],
        교육구분내용: "",
        불러온안전보건교육: [],
        교육진행: [],
        참석자명단: [],
        교육결과_담당자: {
          담당자: "",
          작성일: "",
          의견: "",
        },
        교육결과_교육책임자: {
          담당자: "",
          작성일: "",
          의견: "",
        },
        참고사항: `본 문서는 사내교육시 적용되는 문서입니다.(보관기한 : 5년)
교육결과 의견란에는 각 해당자의 적정 의견을 기재하시기 바랍니다.
[교육담당자] 직영 : 안전환경담당자, 안전장 사내수급업체 : 대표, 수급업체 관리감독자
(* 안전환경담당자 or 안전장이 없는 경우: 관리감독자)
[교육책임자] 직영: 팀장, 사내수급업체:대표
교육참석자 현황을 허위로 등록하였을 경우 관련 법령에 의거 처벌을 받을수 있습니다.`,

        fileList: [],
        진행교육리스트: [], // 목록내 검색용
      },
    };
  },
  computed: {
    // computed
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },

    불러온안전보건교육Ids() {
      return this.form.불러온안전보건교육.map(item => item.id)
    },
  },
  watch: {
    "value": {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(value);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }

        // form.팀업체는 Array 타입인데, 과거에 저장된 데이터의 경우 오브젝트로 저장되어 있다.
        // 이런 경우, 오브젝트를 첫번째 요소로 하는 배열로 변환한다.
        if (value.팀업체 && !Array.isArray(value.팀업체)) {
          this.form.팀업체 = [value.팀업체];
          this.form.팀리스트1차 = [[]];
          this.form.팀리스트2차 = [[]];
        }
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.stdInfo.field_name': {
      immediate: true,
      handler(value) {
        if (value) {
          this.form.공장 = value;
        }
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    async validate() {
      // 선택한 안전보건교육을 사용중인 문서가 있는지 검사
      if (this.불러온안전보건교육Ids.length > 0) {
        const payload = {
          projectId: this.projectId,
          boardId: this.boardId, // boardId = 1007
          boardSlug: `board-${this.boardId}`,
          page: 1,
          perPage: this.불러온안전보건교육Ids.length,
          orderTarget: "created_at",
          orderDirection: "desc",
          conditions: [{key: "body.불러온안전보건교육[%].id", operator: "IN", value: this.불러온안전보건교육Ids}, ],
          statusIds: [2, 3, 4], // 등록, 진행중, 승인
        }
        if (this.postId) {
          payload.conditions.push({key: "id", operator: "!=", value: this.postId})
        }
        const response = await this.$store.dispatch("approval/LOAD_POST_ALL", payload);
        if (response.data.length > 0) {
          const 사용중인안전보건교육Ids = [
            ...new Set(response.data.map(item => {
              const body = JSON.parse(item.post_content).body;
              return body.불러온안전보건교육.map(item => item.id);
            }))
          ];
          return `안전보건교육을 사용중인 문서가 있습니다. <br>사용중인 안전보건교육을 삭제 후 다시 시도해주세요.<br>사용중인 문서 ID : ${  사용중인안전보건교육Ids.join(", ")}`;
        }
      }
    },
    setApprovalButtons(template) {
      const statusCode = template.statusCode
      const isRevision = ["rejected"].indexOf(statusCode) > -1;
      const isApproved = ["approved"].indexOf(statusCode) > -1;
      const btn = {
        shouldShow: {mode: "c|u", freePass: 0, permission: "u", onlyWriter: false, custom: !(isRevision || isApproved)},
        component: "vs-button",
        props: {class: "", color: "secondary", type: "border"},
        content: "안전보건교육 불러오기",
        emits: {
          click: (func) => {
            this.showListPopup = true;
          },
        },
      }

      return [btn, template.print, template.delete, template.move, template.save]
    },

    initFormData() {
      this.form.교육인원대상자수 = 0;
      this.form.교육인원참석자수 = 0;
      this.form.교육구분내용 = "";
      this.form.교육진행 = [];
      this.form.참석자명단 = [];
      this.form.교육구분 = [
        {check: false, comment: '', value: "관리감독자교육", text: "관리감독자교육"},
        {check: false, comment: '', value: "환경교육직무보수교육", text: "환경교육직무보수교육"},
        {check: false, comment: '', value: "TQM교육", text: "TQM교육"},
        {check: false, comment: '', value: "외부업체교육", text: "외부업체교육"},
        {check: false, comment: '', value: "소방교육", text: "소방교육"},
        {check: false, comment: '', value: "특별안전보건", text: "특별안전보건교육"},
        {check: false, comment: '', value: "정기안전보건", text: "정기안전보건교육"},
        {check: false, comment: '', value: "신입사원교육", text: "신입사원교육"},
        {check: false, comment: '', value: "직무전환교육", text: "직무전환교육"},
        {check: false, comment: '', value: "기타교육", text: "기타교육"},
      ]
    },
    setFormData() {
      let 교육인원대상자수 = 0
      let 교육인원참석자수 = 0
      const 참석자명단Map = new Map();

      this.initFormData()
      this.form.loadFormList = []
      this.form.진행교육리스트 = []
      for (const item of this.form.불러온안전보건교육) {
        const content = item.content
        if (content) {
          this.form.loadFormList.push(item)

          if (content.교육인원대상자수 && !isNaN(Number(content.교육인원대상자수))) {
            교육인원대상자수 += Number(content.교육인원대상자수)
          }
          if (content.교육인원참석자수 && !isNaN(Number(content.교육인원참석자수))) {
            교육인원참석자수 += Number(content.교육인원참석자수)
          }

          if (content.교육구분) {
            for (const formItem of this.form.교육구분) {
              if (formItem.value === content.교육구분) {
                formItem.check = true;
                formItem.comment += `${content.교육구분내용} `;

                if (!this.form.진행교육리스트.includes(formItem.text)) {
                  this.form.진행교육리스트.push(formItem.text);
                }
              }
            }
          }

          if (content.교육진행.length > 0) {
            this.form.교육진행 = this.form.교육진행.concat(content.교육진행);
          }

          // 변환
          if (content.참석자명단.length > 0) {
            for (const attendee of content.참석자명단) {
              const key = `${attendee.업체명}-${attendee.교육평가}`;
              if (참석자명단Map.has(key)) {
                const current = 참석자명단Map.get(key);
                const currentCount = parseInt(current.인원.match(/\d+/)) || 0;
                current.인원 = `${currentCount + 1}명`;
              } else {
                참석자명단Map.set(key, {
                  업체명: attendee.업체명,
                  인원: '1명',
                  교육평가: attendee.교육평가,
                });
              }
            }
          }
        }
      }

      this.form.교육인원대상자수 = 교육인원대상자수;
      this.form.교육인원참석자수 = 교육인원참석자수;
      this.form.참석자명단 = Array.from(참석자명단Map.values());
    },

    loadGoalData(data) {
      if (data.length === 0) return;
      this.form.불러온안전보건교육 = data
      this.setFormData()
    },

    printMemberList() {
      if (this.form.loadFormList.length === 0) {
        this.$vs.notify({
          title: '알림',
          text: '출력할 교육이 없습니다.',
          color: 'warning'
        });
        return;
      }

      try {
        // 데이터를 localStorage에 임시 저장
        const timestamp = new Date().getTime(); // 고유 키 생성
        const storageKey = `print_data_${timestamp}`;

        // 데이터 저장
        localStorage.setItem(storageKey, JSON.stringify(this.form.loadFormList));
        localStorage.setItem(`${storageKey}_board`, JSON.stringify(this.board));

        // URL 파라미터로는 스토리지 키만 전달
        const params = new URLSearchParams();
        params.append('storageKey', storageKey);

        // 새 창 열기
        const printWindow = window.open(
          `${window.location.origin}/print-member?${params.toString()}`,
          '_blank',
          `width=${screen.width},height=${screen.height}`
        );

        // 창이 닫힐 때 처리 및 임시 데이터 정리
        if (printWindow) {
          printWindow.onafterprint = () => {
            localStorage.removeItem(storageKey);
            localStorage.removeItem(`${storageKey}_board`);
            printWindow.close();
          };

          // 일정 시간 후에도 데이터 정리 (백업용)
          setTimeout(() => {
            localStorage.removeItem(storageKey);
            localStorage.removeItem(`${storageKey}_board`);
          }, 300000); // 5분 후 삭제
        }
      } catch (error) {
        console.error('프린트 창 열기 실패:', error);
        this.$vs.notify({
          title: '오류',
          text: '프린트 창을 열 수 없습니다.',
          color: 'danger'
        });
      }
    },

    // ======================= FORM =======================
    changeTarget1(index, data) {
      if (index === null || data === null) return;

      if (this.form.팀업체[index].팀1차) {
        this.form.팀업체[index].팀1차 = {};
      }
      if (this.form.팀업체[index].팀2차) {
        this.form.팀업체[index].팀2차 = {};
      }

      this.form.팀리스트1차[index] = data.child ? data.child : [];
      this.form.팀리스트2차[index] = []
    },
    changeTarget2(index, data) {
      if (!this.form.팀업체[index].팀1차 || this.form.팀업체[index].팀1차.value !== '직접입력') {
        this.form.팀업체[index].팀커스텀 = ''
      }

      if (index === null || data === null) return;

      if (this.form.팀업체[index].팀2차) {
        this.form.팀업체[index].팀2차 = {};
      }

      this.form.팀리스트2차[index] = data.child ? data.child : [];
    },

    isCustomTeam(index) {
      if (!this.form.팀업체[index]) return false;
      return this.form.팀업체[index].팀1차 && this.form.팀업체[index].팀1차.value === '직접입력';
    },
    addTeam() {
      this.form.팀업체.push({
        공장: {},
        팀1차: {},
        팀2차: {},
        팀커스텀: "",
      });
      this.form.팀리스트1차.push([]);
      this.form.팀리스트2차.push([]);
    },
    removeTeam(index) {
      this.form.팀업체.splice(index, 1);
      this.form.팀리스트1차.splice(index, 1);
      this.form.팀리스트2차.splice(index, 1);
    },
    teamList1(index) {
      return this.form.팀리스트1차[index];
    },
    teamList2(index) {
      return this.form.팀리스트2차[index];
    },

    onSelectHistory(history) {
      if (history && history.length > 0) {
        this.form.교육인원참석자수 = history.length;
        this.form.참석자명단 = []
        for (const item of history) {
          this.form.참석자명단.push({
            id: Math.random().toString(36).substr(2, 9),
            업체명: item.업체명,
            소속: item.소속,
            직종: item.직종,
            이름: item.이름,
            휴대폰번호: item.휴대폰번호,
            교육평가: '생략',
            user_id: item.user_id,
            직책: item.직책,
          })
        }
      }
    },

    openNewWindow(id) {
      const url = `${window.location.origin}/project/${this.projectId}/tab/987/write/${id}`;
      const newWindow = window.open(
        url,
        '_blank',
        `width=${screen.width},height=${screen.height}`
      );

      // 보안을 위해 새 창의 참조 제거
      if (newWindow) {
        newWindow.opener = null;
      }
    },
    getDataTeam(content) {
      return `${content.stdInfo.section ? content.stdInfo.section : ''}/${content.stdInfo.date ? content.stdInfo.date : ''}`
    },
    onClickRemove987(안전보건교육) {
      if (!this.board.readonly) {
        const find = this.form.불러온안전보건교육.find(item => item.id === 안전보건교육.id)
        if (find) {
          this.form.불러온안전보건교육 = this.form.불러온안전보건교육.filter(item => item.id !== find.id)
          this.setFormData()
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border-top: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    padding: 10px;
  }
}
</style>
